import Controller from '@ember/controller';

export default class IpadDemoController extends Controller {}
